import { gql } from "graphql-request";

export const ADMIN_CHAT_FEEDBACKS = gql`
  query AdminChatFeedbacks($input: AdminChatFeedbacksInputDto!) {
    adminChatFeedbacks(input: $input) {
      items {
        messageId
        sessionId
        sessionTitle
        workspaceId
        userId
        userEmail
        userName
        rating
        reasons
        details
        messageContentPreview
        messageCreatedAt
        feedbackCreatedAt
        feedbackUpdatedAt
      }
      meta {
        totalCount
        totalPages
        currentPage
        limit
        hasNextPage
        hasPrevPage
      }
    }
  }
`;

export const ADMIN_CHAT_SESSION_DETAIL = gql`
  query AdminChatSessionDetail($input: AdminChatSessionDetailInputDto!) {
    adminChatSessionDetail(input: $input) {
      sessionId
      title
      workspaceId
      sessionCreatedAt
      feedbackMessageId
      truncated
      messages {
        messageId
        role
        content
        createdAt
        feedbackRating
        feedbackReasons
        feedbackDetails
      }
    }
  }
`;
